module.exports = require('./helpers/bundle-url').getBundleURL('5F6Q8') + "logo-dark.eefe0b7f.svg";